import { render, staticRenderFns } from "./Sql.vue?vue&type=template&id=04e0d48d&"
import script from "./Sql.vue?vue&type=script&lang=js&"
export * from "./Sql.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports